'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  hr: {
    marginRight: 0,
    marginLeft: 0,
    marginBottom: 0,
    marginTop: 0,
    height: 1,
    border: 'none',
    backgroundColor: _colors2.default.grey
  },
  text: {
    fontSize: '16px',
    color: _colors2.default.icons,
    padding: '8px 8px 8px 16px',
    borderTop: '1px solid ' + _colors2.default.grey,
    margin: 0,
    cursor: 'default',
    textTransform: 'capitalize',
    fontWeight: 'inherit'
  }
};
module.exports = exports.default;